import {
  RadioButtonGroupMapping,
  RadioButtonType,
} from '@labrav/react-components'
import { convertProductPlanPricingToOffer } from '../../../modules/privateOffer/privateOfferCreation/utils/convertProductPlanPricingToOffer'
import {
  AzureOfferPlan,
  AzurePricingType,
  AzureRecurrentPriceField,
  BillingTerm,
  OfferRecurrentPricingType,
  PaymentOption,
  RecurrentPriceModeType,
} from '../../../modules/privateOffer/types'
import type { ProductPlan } from '../../../modules/productsListing/types'

export const pricingTypeMapping: RadioButtonGroupMapping[] = [
  {
    key: AzurePricingType.LABRA_PERCENTAGE,
    label: 'Discount',
    type: RadioButtonType.STANDARD,
  },
  {
    key: AzurePricingType.ABSOLUTE,
    label: 'Absolute',
    type: RadioButtonType.STANDARD,
  },
]

export const emptyBillingTerms = {
  billingTerm: {
    type: '',
    value: 0,
  },
  paymentOption: {
    type: '',
    value: 0,
  },
  pricePerPaymentInUsd: 0,
}

export const convertProductPlanToOfferPlan = (productPlan: ProductPlan) => {
  const pricingData = convertProductPlanPricingToOffer(productPlan)

  const offerPlan = {
    planId: productPlan?.planId,
    labraPlanId: productPlan.planId,
    azurePlanId: productPlan?.azurePlanId,
    description: productPlan?.description,
    displayName: productPlan?.displayName,
    offerPricingType: OfferRecurrentPricingType.SAASNEWCUSTOMIZEDPLANS,
    pricing: pricingData,
    originalPricing: pricingData,
  }
  return { ...offerPlan }
}

export const getPaymentOptionDisplayValue = (
  billingTerm: BillingTerm,
  paymentOption: PaymentOption
) => {
  const billingTypeValue = billingTerm.type
  const paymentTypeValue = paymentOption.type
  if (billingTypeValue === 'month') {
    if (paymentTypeValue === 'month') {
      return 'One time'
    }
  } else if (billingTypeValue === 'year') {
    if (paymentTypeValue === 'month') {
      return 'Monthly'
    } else if (paymentTypeValue === 'year') {
      if (billingTerm?.value === 1 && paymentOption?.value === 1) {
        return 'One time'
      }
      return 'Yearly'
    }
  }
  return ''
}

export const getBillingTermsList = (
  billingTermItem: BillingTerm,
  billingTermsData: AzureRecurrentPriceField[]
) => {
  return {
    label: `${billingTermItem?.value}${' '}${billingTermItem?.type}`,
    value: `${billingTermItem?.value}${' '}${billingTermItem?.type}`,
    disabled: !!billingTermsData?.find(
      item =>
        item?.billingTerm?.type === billingTermItem?.type &&
        item?.billingTerm?.value === billingTermItem?.value
    ),
  }
}

export const shouldShowMetering = (planRow: AzureOfferPlan) =>
  planRow.pricing?.recurrentPrice?.recurrentPriceMode ===
    RecurrentPriceModeType.FLATRATE &&
  planRow.pricing?.customMeters &&
  Object.keys(planRow.pricing?.customMeters?.meters || {}).length > 0

export const shouldShowUserMinMax = (planRow: AzureOfferPlan) =>
  planRow.pricing?.recurrentPrice?.recurrentPriceMode ===
  RecurrentPriceModeType.PERUSER
